module.exports = __webpack_public_path__ + "fa-regular-400.ad97afd3337e8cda302d.ttf";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-regular-400.ttf
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-regular-400.ttf
// module chunks = styles